export const Types = {
    TIERS_LIST: "TIERS_LIST",
    TIERS_DATA_BYID: "TIERS_DATA_BYID",
    // UPDATE_TRAVELLER_DATA: "UPDATE_TRAVELLER_DATA",

  };
  